module.exports = __webpack_public_path__ + "assets/addline.24c9af2a.svg";